import { render, staticRenderFns } from "./RallyRegisterOtherData.vue?vue&type=template&id=74df7b98&"
import script from "./RallyRegisterOtherData.vue?vue&type=script&lang=ts&"
export * from "./RallyRegisterOtherData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports